export default function ceilDiscount(discount: number | string): number {
    return Math.ceil(Number(discount));
}